import { Portfolio } from './Portfolio';

export default Portfolio;



// WEBPACK FOOTER //
// ./src/components/Portfolio/index.js